import React from 'react';
import { Lock, ArrowUpRight } from 'lucide-react';

interface SubscriptionExpiredOverlayProps {
    visible: boolean;
    featureName: string;
}

const SubscriptionExpiredOverlay: React.FC<SubscriptionExpiredOverlayProps> = ({ visible, featureName }) => {
    if (!visible) return null;

    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center pointer-events-auto">
            {/* Blur Backdrop with darker overlay */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-md" />

            {/* Content matching the style in the image or requested aesthetic */}
            <div className="relative z-10 w-full max-w-[360px] mx-4">
                <div className="bg-[#1a1a1a]/95 border border-white/10 rounded-3xl p-8 flex flex-col items-center shadow-2xl animate-scale-in">
                    {/* Icon */}
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-white/10 to-white/5 flex items-center justify-center mb-6 shadow-inner ring-1 ring-inset ring-white/10">
                        <Lock className="w-6 h-6 text-white/60" />
                    </div>

                    {/* Text */}
                    <h3 className="text-xl font-bold text-white mb-3 text-center tracking-tight">
                        Subscription Expired
                    </h3>

                    <p className="text-white/40 text-sm mb-8 text-center leading-relaxed">
                        Access to <span className="text-white/70 font-medium">{featureName}</span> is restricted.<br />
                        Please renew your plan to continue.
                    </p>

                    {/* Action Button */}
                    <a
                        href="https://ikcore.cloud/pricing"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full py-3.5 bg-white hover:bg-white/90 text-black rounded-xl text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-2 group shadow-[0_0_20px_rgba(255,255,255,0.1)] hover:shadow-[0_0_25px_rgba(255,255,255,0.2)] hover:scale-[1.02]"
                    >
                        <span>Renew Subscription</span>
                        <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionExpiredOverlay;
